var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6101 11.9995C24.6101 8.81705 23.3459 5.76493 21.0956 3.51458C18.8452 1.26424 15.7931 5.12275e-06 12.6106 5.12275e-06C9.58905 -0.00278525 6.67765 1.13446 4.45798 3.18457C2.2383 5.23468 0.873769 8.04673 0.636943 11.059C0.400117 14.0713 1.30843 17.062 3.18046 19.4338C5.05248 21.8056 7.75039 23.3839 10.7353 23.8533V15.4674H7.69082V11.9995H10.737V9.3562C10.737 6.34946 12.5283 4.68667 15.2694 4.68667C16.5825 4.68667 17.9556 4.92152 17.9556 4.92152V7.87511H16.4419C14.9505 7.87511 14.4877 8.80079 14.4877 9.74875V11.9995H17.815L17.2836 15.4674H14.486V23.8533C17.3084 23.4064 19.8788 21.967 21.7347 19.794C23.5906 17.621 24.6102 14.8572 24.6101 11.9995Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c18d070e9d43fd154368761753267560.svg";
export { ForwardRef as ReactComponent };